import React from 'react';
import { useNavigate } from 'react-router-dom';
import "./App.css";

import logoSvant from "./img/svant-logo.svg";

export default function Thanks() {
  const navigate = useNavigate();

  // const userId = localStorage.getItem("ultimoIdUserResponse");

  return (
    <div className='thanks'>
      <div>
        <img
          className='logoSvant'
          src={logoSvant}
          alt="Svant Measure and Act"
        />
        <h1>¡Gracias por sumarte a esta iniciativa!</h1>
        <h3>Medir es el primer paso para mejorar.</h3>
      </div>

      <div>
      </div>
      <button
        style={{ cursor: 'pointer' }}
        onClick={() => navigate('/')}
      >
        Volver
      </button>
    </div>
  );
}
